import React from 'react';
import { useAppSelector } from 'src/hooks/redux-hooks';
import ImageSliderModal from 'src/components/shared/modals/image-slider-modal';
import PausedNotesModal from 'src/components/shared/modals/paused-notes-modal';
import AskQuestionModal from 'src/components/shared/modals/ask-question-modal';
import DescriptionHistoryModal from 'src/components/shared/modals/description-history-modal';
import LocationMapModal from 'src/components/shared/modals/location-map-modal';
import MaintenanceHistoryModal from 'src/components/shared/modals/maintenance-history-modal';
import InvoicedRedirectModal from 'src/components/shared/modals/invoiced-redirect-modal';
import EscalationStatusModal from 'src/components/shared/modals/escalation-status-modal';
import ResidentResponsibilityModal from 'src/components/shared/modals/resident-responsibility-modal';
import ResidentResponsibilityRemoveModal from 'src/components/shared/modals/resident-responsibility-remove-modal';

interface ModalState {
  isVisible?: boolean;
  [key: string]: unknown;
}

const Modals = () => {
  const {
    imageSlidesModal,
    askQuestionModal,
    pausedNotesModal,
    descriptionHistoryModal,
    mapModal,
    maintenanceHistoryModal,
    invoicedRedirectModal,
    escalationStatusModal,
    residentResponsibilityModal,
    residentResponsibilityRemoveModal,
  } = useAppSelector(
    (state: Record<string, unknown>) => (
      state.modals as Record<string, ModalState>
    ),
  );

  return (
    <React.Fragment>
      {imageSlidesModal?.isVisible ? <ImageSliderModal /> : ''}
      {askQuestionModal?.isVisible ? <AskQuestionModal /> : ''}
      {pausedNotesModal?.isVisible ? <PausedNotesModal /> : ''}
      {descriptionHistoryModal?.isVisible ? <DescriptionHistoryModal /> : ''}
      {mapModal?.isVisible ? <LocationMapModal /> : ''}
      {maintenanceHistoryModal?.isVisible ? <MaintenanceHistoryModal /> : ''}
      {invoicedRedirectModal?.isVisible ? <InvoicedRedirectModal /> : ''}
      {escalationStatusModal?.isVisible ? <EscalationStatusModal /> : ''}
      {residentResponsibilityModal?.isVisible ? <ResidentResponsibilityModal /> : ''}
      {residentResponsibilityRemoveModal?.isVisible ? <ResidentResponsibilityRemoveModal /> : ''}
    </React.Fragment>
  );
};
export default Modals;
